import React from "react";
import styles from "./PagesInput.module.css";

const PageInputField = ({
  type = "text",
  label,
  name,
  value,
  onChange,
  placeholder,
  error,
  required = false,
  className = "",
  ...props
}) => {
  return (
    <div className={`${styles.inputContainer} ${className}`}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}

      <div className={styles.inputWrapper}>
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${styles.input} ${error ? styles.error : ""}`}
          {...props}
        />
      </div>

      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
export default PageInputField;
